import { Component, OnInit, Inject } from "@angular/core";
import {
  FormGroup,
  FormBuilder,
  Validators
} from "@angular/forms";

import { SoundEnum } from "src/app/enums/sound.enum";
import { TranslateService } from "@ngstack/translate";
import { ErrorsService } from "src/app/services/common/errors.service";
import { SnackBarService } from "src/app/services/common/snackBar.service";
import { CalendarService } from "src/app/services/http/business/calendar/calendar.service";
import { ICalendar } from "src/app/interfaces/calendar";
import { TermInfoService } from "src/app/services/http/business/term-info/term-info.service";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material";
import { IParentTerm } from "src/app/interfaces/parent-term";
import { IError } from "src/app/interfaces/error.interface";

@Component({
  selector: 'app-toggle-terminfo',
  templateUrl: './toggle-terminfo.component.html',
  styleUrls: ['./toggle-terminfo.component.css']
})
export class ToggleTerminfoComponent implements OnInit {
  yearList: ICalendar;
  param: any;
  errorList: IError[] = [];
  errObject: any;
  form: FormGroup;
  errors = new Array();
  constructor(
    private fb: FormBuilder,
    private snackBar: SnackBarService,
    public translate: TranslateService,
    private errorService: ErrorsService,
    private calendarService: CalendarService,
    private terminfoService: TermInfoService,
    private DialogRef: MatDialogRef<ToggleTerminfoComponent>,
    @Inject(MAT_DIALOG_DATA) public data: IParentTerm
  ) { }

  ngOnInit() {
    this.createForm();
    this.loadYear();
  }

  createForm() {
    this.form = this.fb.group({
      ParentTermId: [this.data.Id],
      Year: [null, Validators.compose([Validators.required])],
      State: [null, Validators.compose([Validators.required])],
    });
  }

  loadYear() {
    this.calendarService.yearList().subscribe(
      res => {
        this.yearList = res;
      },
      () => {
        this.errorService.transactionError();
      }
    );
  }

  closeModal() {
    this.DialogRef.close();
  }

  submit(data: any) {
    debugger
    if (data) {
      data.State = (data.State == 'true');
      this.terminfoService.ToggleTermInParentTerm(data).subscribe(
        () => {
          this.snackBar.OpenSnackBar(
            'تغییر وضعیت ترم ها با موفقیت انجام شد',
            "ok",
            5000,
            SoundEnum.beep
          );
          this.closeModal();
        },
        err => {
          // this.errObject = this.errorService.getError(err);
          // this.param = this.errorService.objectError(this.errObject);
          // this.errors = this.errorService.returnError(err);
          this.errorList = this.errorService.getErrorList(err.error);
        }
      );
    }
  }
}
